import Component from '../Component';
import { GameObjectEvent } from '../../GameObject/GameObject';
import { StartAnimation } from '../../System/Animation/AnimationHelper';
import Game from '../../Game';
import Interactable from '../Interactable';
import LevelNode from '../../Prototype/World/LevelNode/LevelNode';
import { PlayerActions } from '../../State/Player/PlayerActions';
import LevelNodeState from '../../Prototype/World/LevelNode/LevelNodeState';
import PIXIRenderer from '../../System/Render/PIXIRenderer';

export default class LevelNodeComponent extends Component<
    PIXI.Container,
    LevelNode
> {
    public id: string = undefined;
    public x: number = undefined;
    public y: number = undefined;
    public number: number = undefined;
    public levelNodeState: LevelNodeState = undefined;
    public isStarChestLevel: boolean = undefined;
    private onDownViewportX: number = 0;

    public onAttach(
        gameObject: LevelNode,
        container: PIXI.Container,
        params: any
    ) {
        super.onAttach(gameObject, container, params);
        this.handleDefaultListeners(true);
    }
    public onDetach(gameObject: LevelNode, container: PIXI.Container) {
        this.handleDefaultListeners(false);
        super.onDetach(gameObject, container);
    }

    private handleDefaultListeners(enable: boolean) {
        if (enable) {
            const futureLevel = this.levelNodeState === LevelNodeState.FUTURE;

            const canHaveInput = !futureLevel || this.isStarChestLevel;

            const interactable = this.gameObject.getComponent(Interactable);
            interactable.enabled = canHaveInput;
            interactable.buttonMode = canHaveInput;

            if (canHaveInput) {
                if (!futureLevel) {
                    this.gameObject.on(
                        GameObjectEvent.POINTER_DOWN,
                        this.handleNodePress
                    );
                    this.gameObject.on(
                        GameObjectEvent.POINTER_UP,
                        this.animateNodeRelease
                    );
                    this.gameObject.on(
                        GameObjectEvent.POINTER_OUT,
                        this.animateNodeRelease
                    );
                }
                this.gameObject.on(GameObjectEvent.SELECTED, this.onSelected);
            }
        } else {
            this.gameObject.off(
                GameObjectEvent.POINTER_DOWN,
                this.handleNodePress
            );
            this.gameObject.off(
                GameObjectEvent.POINTER_UP,
                this.animateNodeRelease
            );
            this.gameObject.off(
                GameObjectEvent.POINTER_OUT,
                this.animateNodeRelease
            );
            this.gameObject.off(GameObjectEvent.SELECTED, this.onSelected);
        }
    }

    private readonly handleNodePress = () => {
        this.onDownViewportX = PIXIRenderer.mapViewport.x;
        StartAnimation(this.gameObject, 'NodePress');
    };

    private readonly animateNodeRelease = () => {
        StartAnimation(this.gameObject, 'NodeRelease');
    };

    private readonly onSelected = () => {
        if (Math.abs(this.onDownViewportX - PIXIRenderer.mapViewport.x) > 1) return;

        PlayerActions.showLevelAutoFlowPopup({ levelNumber: this.number, allowRandomizedLevelSelection: false });
    };
}
